import SuperFetchV2 from '../../superFetchV2';

export type RequestDownloadLuckyDrawParticipantsResult = {
  adminEmail: string;
};

class LuckyDrawApiV2 {
  requestDownloadLuckyDrawParticipants = (code: string): Promise<RequestDownloadLuckyDrawParticipantsResult> =>
    SuperFetchV2.post(`/lucky-draw-participants/download`, {
      luckyDrawCode: code,
    });
}

export const luckyDrawApiV2 = new LuckyDrawApiV2();
